
var MyDataModule = function(){
	var scope = ".js-mod-my-data";
	ui.ready(
        scope,
		function($mod){
            var $addressModal = $mod.find(scope+"__create-address-modal").clone();
            ui.init($addressModal);
		    var $dataForm = $mod.find(scope+"__form");
            $dataForm.submit(
                function(ev){
					ev.preventDefault();
					var $button = $dataForm.find(scope+"__button");
                    var isOk = $dataForm.checkRestrictions();
                    if(isOk){
                        $button.prop("disabled",true);
                        gvf.endpoint(
                        	"web\\webUserPrivateController::updateWebUserData",
                            [$dataForm.getValues()],
                            function(response){
                                $button.prop("disabled",false);
                                utils.alertEndpointResponse(response);
                            }
                        );
                    }
                }
            );

     		$mod.find(scope+"__delete-invoice-btn").click(
                function(ev){
                    ev.preventDefault();
                    var $li = $(this).closest("li");
                    var invoiceAddressId = $li.data("id");
                    var endpointResponse = null;
                    Swal.fire({
                           title:$mod.attr('data-confirm-alert'),
                           text:$mod.attr('data-confirm-text'),
                           showCancelButton:true,
                           preConfirm: function() {
                            return new Promise(function(resolve,reject) {
                               gvf.endpoint(
                                    "web\\addressController::deleteInvoiceAddress",
                                    [invoiceAddressId],
                                    function(response){
                                        if(response.status=="ok"){
                                            endpointResponse = response;
                                            resolve();
                                        }else{
                                            reject(response);
                                        }
                                    }
                                );
                            }).catch(
                                function(error){
                                    Swal.showValidationMessage(error.messages);
                                }
                            );
                        }
                    }).then(
                        function(response){
                            if(response.isConfirmed && endpointResponse.status=="ok"){
                                $li.remove();
                            }else{
                                utils.alertEndpointResponse(endpointResponse);
                            }
                        }
                    );
                }
            );

            $mod.find(scope+"__delete-deliver-btn").click(
                function(ev){
                    ev.preventDefault();
                    var $li = $(this).closest("li");
                    var deliverAddressId = $li.data("id");
                    Swal.fire({
                        title:$mod.attr('data-confirm-alert'),
                        text:$mod.attr('data-confirm-text'),
                        showCancelButton:true,
                        preConfirm: function() {
                            return new Promise(function(resolve,reject) {
                                gvf.endpoint(
                                    "web\\addressController::deleteDeliverAddress",
                                    [deliverAddressId],
                                    function(response){
                                        if(response.status=="ok"){
                                            endpointResponse = response;
                                            resolve();
                                        }else{
                                            reject(response);
                                        }
                                    }
                                );
                            }).catch(
                                function(error){
                                    Swal.showValidationMessage(error.messages);
                                }
                            );
                        }
                    }).then(
                        function(response){
                            if(response.isConfirmed && endpointResponse.status=="ok"){
                                $li.remove();
                            }else{
                                utils.alertEndpointResponse(endpointResponse);
                            }
                        }
                    );
                }
             );

            $mod.find(scope+"__edit-invoice-btn").click(
                function(ev){
                    ev.preventDefault();
                    var invoiceAddressId = $(this).closest("li").data("id");
                    if(invoiceAddressId>0){
                        var $addressModalBody = $mod.find(scope+"__create-address-modal-body");

                        gvf.endpoint("web\\addressController::createOrEditInvoiceAddressForm",[invoiceAddressId],function(response){
                            if(response.status=="ok"){
                                var $addressModalBody = $addressModal.find(scope+"__create-address-modal-body");
                                $addressModalBody.empty();
                                $addressModal.find("#createAddressModalTitle").text(response.title);
                                $addressModalBody.append(response.html);
                                ui.init($addressModalBody);
                                $addressModal.modal('show');
                                var $dataFormEditInvoiceAddress = $addressModal.find(scope+"__form-edit-invoice-address");
                                $dataFormEditInvoiceAddress.submit(
                                    function(ev){
                                        ev.preventDefault();
                                        fOk();
                                    }
                                );
                            }else{
                                utils.alertEndpointResponse(response);
                            }

                            function fOk(){
                                var $dataFormEditInvoiceAddress = $addressModal.find(scope+"__form-edit-invoice-address");
                                var $button = $dataFormEditInvoiceAddress.find(scope+"__button");
                                $button.prop("disabled",true);
                                gvf.endpoint(
                                    "web\\addressController::editInvoiceAddress",
                                    [invoiceAddressId,$dataFormEditInvoiceAddress.getValues()],
                                    function(response){
                                        $button.prop("disabled",false);
                                        if(response.status=="ok"){
                                            $addressModal.modal('hide');
                                            utils.alertEndpointResponse(
                                                response,
                                                function(){
                                                    window.location.reload();
                                                }
                                            );
                                        }else{
                                            utils.alertEndpointResponse(response);
                                        }
                                    }
                                );

                            }
                        });
                    }else{
                        Swal.fire(
                            {
                                icon: "error",
                                text: $mod.attr('data-error-delivery')
                            }
                        );

                    }
                }

            );
            $mod.find(scope+"__edit-deliver-btn").click(
                function(ev){
                    ev.preventDefault();
                    var deliverAddressId = $(this).closest("li").data("id");
                    if(deliverAddressId>0){
                        gvf.endpoint("web\\addressController::createOrEditDeliverAddressForm",
                            [deliverAddressId],
                            function(response){
                                if(response.status=="ok"){
                                    var $addressModalBody = $addressModal.find(scope+"__create-address-modal-body");
                                    $addressModalBody.empty();
                                    $addressModal.find("#createAddressModalTitle").text(response.title);
                                    $addressModalBody.append(response.html);
                                    ui.init($addressModalBody);
                                    $addressModal.modal('show');
                                    var $dataFormEditDeliverAddress = $addressModal.find(scope+"__form-edit-deliver-address");
                                    $dataFormEditDeliverAddress.submit(
                                        function(ev){
                                            ev.preventDefault();
                                            fOk();

                                        }
                                    );
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                                function fOk(){
                                    var $dataFormEditDeliverAddress = $addressModal.find(scope+"__form-edit-deliver-address");
                                    var $button = $dataFormEditDeliverAddress.find(scope+"__button");
                                    $button.prop("disabled",true);
                                    gvf.endpoint(
                                        "web\\addressController::editDeliverAddress",
                                        [deliverAddressId,$dataFormEditDeliverAddress.getValues()],
                                        function(response){
                                            $button.prop("disabled",false);
                                            if(response.status=="ok"){
                                                $addressModal.modal('hide');
                                                utils.alertEndpointResponse(
                                                    response,
                                                    function(){
                                                        window.location.reload();
                                                    }
                                                );
                                            }else{
                                                utils.alertEndpointResponse(response);
                                            }
                                        }
                                    );
                                }
                            }
                        );
                    }else{
                        Swal.fire(
                            {
                                icon: "error",
                                text: $mod.attr('data-error-delivery')
                            }
                        );
                    }

                }
            );
            $mod.find(scope+"__btn-add-deliver").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\addressController::createOrEditDeliverAddressForm",
                        [],
                        function(response){
                            if(response.status=="ok"){
                                var $addressModalBody = $addressModal.find(scope+"__create-address-modal-body");
                                $addressModalBody.empty();
                                $addressModal.find("#createAddressModalTitle").text(response.title);
                                $addressModalBody.append(response.html);
                                ui.init($addressModalBody);
                                $addressModal.modal('show');
                                var $dataFormCreateDeliverAddress = $addressModalBody.find(scope+"__form-create-deliver-address");
                                $dataFormCreateDeliverAddress.submit(
                                    function(ev){
                                        ev.preventDefault();
                                        fOk();

                                    }
                                );
                            }else{
                                utils.alertEndpointResponse(response.messages);
                            }
                            function fOk(){
                                var $dataFormCreateDeliverAddress = $addressModal.find(scope+"__form-create-deliver-address");
                                var $button = $dataFormCreateDeliverAddress.find(scope+"__button");
                                $button.prop("disabled",true);
                                gvf.endpoint(
                                        "web\\addressController::createDeliverAddress",
                                        [$dataFormCreateDeliverAddress.getValues()],
                                        function(response){
                                            $button.prop("disabled",false);
                                            if(response.status=="ok"){
                                                $addressModal.modal('hide');
                                                utils.alertEndpointResponse(
                                                    response,
                                                    function(){
                                                        window.location.reload();
                                                    }
                                                );
                                            }else{
                                                utils.alertEndpointResponse(response);
                                            }
                                        }
                                );

                            }


                        }
                    );
                }
            );
            $mod.find(scope+"__btn-add-invoice").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\addressController::createOrEditInvoiceAddressForm",
                        [],
                        function(response){
                            if(response.status=="ok"){
                                 var $addressModalBody = $addressModal.find(scope+"__create-address-modal-body");
                                $addressModalBody.empty();
                                $addressModal.find("#createAddressModalTitle").text(response.title);
                                $addressModalBody.append(response.html);
                                ui.init($addressModalBody);
                                $addressModal.modal('show');
                                var $dataFormCreateInvoiceAddress = $addressModalBody.find(scope+"__form-create-invoice-address");
                                $dataFormCreateInvoiceAddress.submit(
                                    function(ev){
                                        ev.preventDefault();
                                        fOk();

                                    }
                                );
                            }else{
                                utils.alertEndpointResponse(response.messages);
                            }
                            function fOk(){
                                var $dataFormCreateInvoiceAddress  = $addressModal.find(scope+"__form-create-invoice-address");
                                var $button = $dataFormCreateInvoiceAddress.find(scope+"__button");
                                $button.prop("disabled",true);
                                gvf.endpoint(
                                    "web\\addressController::createInvoiceAddress",
                                    [$dataFormCreateInvoiceAddress.getValues()],
                                    function(response){
                                        $button.prop("disabled",false);
                                        if(response.status=="ok"){
                                            $addressModal.modal('hide');
                                            utils.alertEndpointResponse(
                                                response,
                                                function(){
                                                    window.location.reload();
                                                }
                                            );
                                        }else{
                                            utils.alertEndpointResponse(response);
                                        }
                                    }
                                );
                            }
                        }
                    );
                }
            );
		}
	);
}();

